
/**
 * Hook para implementar debounce em valores
 * 
 * Útil para otimizar buscas em tempo real, evitando
 * muitas requisições desnecessárias enquanto o usuário digita.
 * 
 * @param value - Valor a ser "debouncado"
 * @param delay - Tempo de atraso em milissegundos
 * @returns Valor com debounce aplicado
 */

import { useState, useEffect } from 'react';

export const useDebounce = <T>(value: T, delay: number): T => {
  // Estado para armazenar o valor com debounce
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Configurar timer para atualizar o valor após o delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Limpar timeout se o valor mudar antes do delay
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};
